import { render } from "./RegistCard.vue?vue&type=template&id=f28a85f0"
import script from "./RegistCard.vue?vue&type=script&lang=js"
export * from "./RegistCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__